import { useTranslation } from "react-i18next"
import { ScrollWrapper } from "@/components/scroll-wrapper"
import { MedicationItem } from "@/modules/patients/detail/medication/de/medication-item"
import { deMedicationFragmentInline$data } from "@/modules/patients/detail/medication/de/services/__generated__/deMedicationFragmentInline.graphql"
import { DeMedicationFragmentInlineList } from "@/modules/patients/detail/medication/types/medication-fragment-type"

type MedicationViewerProps = {
  activeMedicationList: DeMedicationFragmentInlineList
  inactiveMedicationList: DeMedicationFragmentInlineList
  handleSelectExistingMedication: (medication: deMedicationFragmentInline$data) => void
}

const MedicationViewer = ({
  activeMedicationList,
  inactiveMedicationList,
  handleSelectExistingMedication,
}: MedicationViewerProps) => {
  const { t } = useTranslation()

  return (
    <ScrollWrapper className="py-4">
      <div className="overflow-hidden">
        <div className="grid gap-8">
          {/* Active */}
          {activeMedicationList.length > 0 && (
            <div className="overflow-hidden" data-testid="active-medication-section">
              <p className="pb-4 font-medium">{t("patient.medication.active")}</p>
              {activeMedicationList.map((medication) => (
                <MedicationItem
                  key={medication.id}
                  medicationData={medication}
                  isActive
                  handleSelectExistingMedication={handleSelectExistingMedication}
                />
              ))}
            </div>
          )}
          {/* Inactive */}
          {inactiveMedicationList.length > 0 && (
            <div className="overflow-hidden" data-testid="inactive-medication-section">
              <p className="pb-4 font-medium">{t("patient.medication.inactive")}</p>
              {inactiveMedicationList.map((medication) => (
                <MedicationItem
                  key={medication.id}
                  medicationData={medication}
                  handleSelectExistingMedication={handleSelectExistingMedication}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </ScrollWrapper>
  )
}

export { MedicationViewer }
